import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 16271 17403"
    {...props}
  >
    <rect
      width={2042}
      height={6806}
      x={7114}
      y={308}
      rx={772}
      ry={919}
      style={{
        fill: "#1c1b17",
        stroke: "#1c1b17",
        strokeWidth: 617.158,
      }}
      className="fill stroke1"
    />
    <path
      d="M11443 2175c827 385 1578 915 2222 1559l5 4c643 644 1173 1396 1559 2223 912 1957 944 4100 259 5982-685 1884-2089 3506-4045 4419-1957 912-4100 944-5983 259-1884-686-3506-2089-4418-4046-912-1956-944-4099-260-5982 686-1884 2089-3506 4046-4418l862 1850c-1449 676-2488 1874-2993 3262-506 1390-481 2977 195 4427 676 1448 1874 2487 3263 2993 1390 505 2976 480 4426-196 1449-675 2487-1874 2993-3262 506-1390 481-2976-195-4426-290-621-680-1177-1149-1646l-4-3c-468-469-1025-860-1645-1149l862-1850z"
      style={{
        fill: "#1c1b17",
        fillRule: "nonzero",
        stroke: "#1c1b17",
        strokeWidth: 617.158,
      }}
      className="fill stroke1"

    />
  </svg>
);
export default SvgComponent;
